import React from 'react';

const PAYMENT_OPTIONS = [
  { value: 'cash', label: 'À Vista' },
  { value: 'financing', label: 'Financiamento' },
  { value: 'mixed', label: 'Entrada + Financiamento' },
];

export const QuestionarioCarrosStepFour = ({ formData, handleChange }) => {
  return (
    <div className="space-y-4" data-testid="questionario-carros-step-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Forma de Pagamento *</label>
        <div className="flex gap-4" data-testid="questionario-carros-payment-options">
          {PAYMENT_OPTIONS.map((option) => (
            <label key={option.value} className="flex items-center gap-2 cursor-pointer" data-testid={`questionario-carros-payment-option-${option.value}`}>
              <input
                type="radio"
                name="paymentMethod"
                value={option.value}
                checked={formData.paymentMethod === option.value}
                onChange={handleChange}
                className="w-4 h-4 text-orange-600 border-gray-300 focus:ring-orange-500"
                data-testid={`questionario-carros-payment-radio-${option.value}`}
              />
              <span className="text-gray-700">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="bg-gray-50 p-4 rounded-lg" data-testid="questionario-carros-tradein-block">
        <label className="flex items-center gap-2 cursor-pointer" data-testid="questionario-carros-tradein-toggle-label">
          <input
            type="checkbox"
            name="hasTradein"
            checked={formData.hasTradein}
            onChange={handleChange}
            className="w-5 h-5 text-orange-600 border-gray-300 rounded focus:ring-orange-500"
            data-testid="questionario-carros-tradein-checkbox"
          />
          <span className="text-gray-700 font-medium">Tenho um carro para dar na troca</span>
        </label>
        {formData.hasTradein && (
          <textarea
            name="tradeinDetails"
            value={formData.tradeinDetails}
            onChange={handleChange}
            rows={3}
            className="w-full mt-3 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 resize-none"
            placeholder="Descreva seu carro atual (marca, modelo, ano, km...)"
            data-testid="questionario-carros-tradein-details-textarea"
          />
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Urgência *</label>
        <select
          name="urgency"
          value={formData.urgency}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
          data-testid="questionario-carros-urgency-select"
        >
          <option value="">Selecione</option>
          <option value="imediato">Imediato</option>
          <option value="1mes">Em 1 mês</option>
          <option value="3meses">Em 3 meses</option>
          <option value="sempressa">Sem pressa</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Observações</label>
        <textarea
          name="observations"
          value={formData.observations}
          onChange={handleChange}
          rows={3}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 resize-none"
          placeholder="Alguma preferência adicional?"
          data-testid="questionario-carros-observations-textarea"
        />
      </div>
    </div>
  );
};
